import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { HttpService } from "./http.service";
import { ConfigurationService } from "./configuration.service";
import { Observable } from "rxjs";
import { EmptyDto, MaintenanceLogDto } from "app/models";


@Injectable()
export class MaintenanceService extends BaseService {
    constructor(httpService: HttpService,
        configurationService: ConfigurationService) {
            super(httpService, configurationService);
    }

    clearTransferBids(): Observable<MaintenanceLogDto> {
        return this.httpService.post<MaintenanceLogDto>(this.apiUrl + 'maintenance/clear-transfer-bids', null, null, true);
    }

    getLatestLogs(): Observable<MaintenanceLogDto[]> {
        return this.httpService.get<MaintenanceLogDto[]>(this.apiUrl + 'maintenance/latest', null, true);
    }

    clearRentList(): Observable<MaintenanceLogDto> {
        return this.httpService.post<MaintenanceLogDto>(this.apiUrl + 'maintenance/rent-list/clear', null, null, true);
    }

    clearTransferList(): Observable<MaintenanceLogDto> {
        return this.httpService.post<MaintenanceLogDto>(this.apiUrl + 'maintenance/transfer-list/clear', null, null, true);
    }

    backRent(): Observable<MaintenanceLogDto> {
        return this.httpService.post<MaintenanceLogDto>(this.apiUrl + 'maintenance/rent/back', null, null, true);
    }

    backRentHalfSeason(): Observable<MaintenanceLogDto> {
        return this.httpService.post<MaintenanceLogDto>(this.apiUrl + 'maintenance/rent/half-season-back', null, null, true);
    }

    setMidSeasonForm(): Observable<MaintenanceLogDto> {
        return this.httpService.post<MaintenanceLogDto>(this.apiUrl + 'maintenance/midseason/form', null, null, true);
    }

    clearCache(): Observable<EmptyDto> {
        return this.httpService.post<EmptyDto>(this.apiUrl + 'maintenance/cache', null, null, true);
    }
}